module.exports = __webpack_public_path__ + "static/img/spread2-2.51ffd62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread2-2.jpg
// module id = U7a7
// module chunks = 1